import React from 'react';
import { Banner as StyledBanner, BannerTertiaryText, BannerMainImage } from './styled/skylab/page';
import { setPartnerBannerLogo } from './helpers/banner';
const Banner = ({ additionalClass, backgroundImage, image, partnerLogo, primaryText, secondaryText, tertiaryText, partnerSignup, isMrsTrustfile = false, }) => (React.createElement(StyledBanner, { className: additionalClass || '', backgroundImage: backgroundImage || '' },
    React.createElement("div", null,
        React.createElement("div", { className: 'banner-content', "data-ref": 'buy.banner-content' },
            React.createElement("h1", { "data-ref": 'buy.banner.header', id: 'banner-title' },
                primaryText,
                partnerLogo && setPartnerBannerLogo(partnerLogo)),
            (partnerSignup || secondaryText) &&
                React.createElement("h2", { "data-ref": 'buy.banner.secondary-header' },
                    partnerSignup && `Avalara AvaTax for ${partnerSignup.name}`,
                    !partnerSignup && secondaryText != null && secondaryText),
            tertiaryText != null && tertiaryText &&
                React.createElement(BannerTertiaryText, { "data-ref": 'buy.banner.tertiary-content', hasBackgroundImage: backgroundImage != null }, tertiaryText)),
        image != null &&
            React.createElement(BannerMainImage, { src: image, alt: 'Banner image', isBundle: additionalClass === 'isBundle', isMrsTrustfile: isMrsTrustfile }))));
export default Banner;
